
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.008 11v-.383c.385-.068.635-.17.75-.305.114-.135.172-.328.172-.578 0-.28-.081-.703-.242-1.265L4.859 2.094 2.72 8.227c-.224.64-.336 1.112-.336 1.414 0 .562.315.888.945.976V11H.047v-.383c.328-.062.583-.221.765-.476.183-.26.383-.685.602-1.274L4.656.211H5.68l2.633 8.71c.218.725.408 1.173.57 1.345.166.166.385.284.656.351V11H6.008z","fill":"currentColor"}})])
          )
        }
      }
    